<template>
  <component :is="editing ? 'portal' : 'div'" to="mission-center">
    <transition name="el-fade-in-linear">
      <div v-if="$store.state.site.missionCenterVisible" class="mission-center-dialog" :class="{ 'is-mobile': $store.getters.isMobile }" :style="getStyle">
        <div class="mission-center-dialog__content">
          <div class="relative p-5">
            <div v-if="!editing" class="text-right">
              <i class="el-icon-close cursor-pointer font-bold text-[20px]" @click="handleClose" />
            </div>
            <rich-text v-model="model.title" class="title" :disabled="!editing" :editing="editing" />
            <div v-loading="loading" class="list">
              <el-empty v-if="!loading && !list.length" class="py-0" description=" " />
              <div v-for="item in list" :key="item.task_id" class="item">
                <div class="left-info">
                  <div class="name">{{ item.name }}</div>
                  <div v-for="(giftBox, giftsBoxIndex) in item.gifts" :key="giftsBoxIndex + 'giftBox'" class="gift-list">
                    <div v-for="(gift, giftIndex) in giftBox.gift_list" :key="giftIndex + 'gift'" class="gift-item">
                      <img :src="gift.gift_goods_logo" alt="">
                      <span>
                        <i class="el-icon-close"></i>
                        <em class="not-italic">{{ gift.num }}</em>
                      </span>
                    </div>
                  </div>
                </div>
                <template v-if="item.type === MissionCenterTypeEnums.PwaLogin">
                  <div v-if="item.gifts[0].status === 3" class="right-handle submit-type" @click="handlePwaLoginSubmit">
                    {{ pwaLoginSubmitText  }}
                  </div>
                  <div v-if="item.gifts[0].status === 2" class="right-handle get-type" @click="handleGetGift(item.gifts[0])">
                    {{ $t('siteBuild.activity.get') }}
                  </div>
                  <div v-if="item.gifts[0].status === 1" class="right-handle done-type">
                    {{ $t('siteBuild.done') }}
                  </div>
                </template>
              </div>
            </div>
            <div v-if="canQuickGet" class="handle-area" @click="handleQuickGet">
              <div class="quick-button">{{ $t('siteBuild.quickGet') }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </component>
</template>

<script>
import { Dialog, Message, Empty } from 'element-ui'
import cloneDeep from 'lodash.clonedeep'
import RichText from '~/components/richText/index.vue'
import { getLangIdI18n, getTextColor, isPwa } from '~/utils'
import Bus from "~/site/model/bus"
import { MissionCenterTypeEnums } from '~/enums/data'
import { getUserInfo, showLogin } from '~/site/core'
export default {
  name: 'MissionCenterSetting',
  components: {
    RichText,
    [Dialog.name]: Dialog,
    [Empty.name]: Empty
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inPwa: false,
      loading: false,
      list: [],
      MissionCenterTypeEnums
    }
  },
  computed: {
    canQuickGet() {
      return this.list.some(item => item.gifts[0].status === 2)
    },
    userInfo() {
      return this.$store.state.user.siteUserInfo
    },
    pwaLoginSubmitText() {
      if (this.editing) {
        return this.$t('siteBuild.do')
      } else if (this.inPwa && !this.userInfo?.id) {
        return this.$t('siteBuild.header.login')
      } else if (!this.inPwa) {
        return this.$t('siteBuild.install')
      } else {
        return 'null'
      }
    },
    getStyle() {
      const { background, rowBackground, textColor, submitBackground, getBackground, getColor, submitColor, doneBackground, doneColor } = this.model
      return {
        '--mission-border-radius': '4px',
        '--mission-background-color': getTextColor(background).color,
        '--mission-text-color': getTextColor(textColor).color,
        '--mission-item-bg': getTextColor(rowBackground).color,
        '--mission-submit-color': getTextColor(submitColor).color,
        '--mission-submit-bg': getTextColor(submitBackground).color,
        '--mission-get-color': getTextColor(getColor).color,
        '--mission-get-bg': getTextColor(getBackground).color,
        '--mission-done-color': getTextColor(doneColor).color,
        '--mission-done-bg': getTextColor(doneBackground).color
      }
    }
  },
  watch: {
    '$store.state.site.missionCenterVisible'(newVal) {
      this.$nextTick(() => {
        newVal && this.init()
      })
    }
  },
  destroyed() {
    Bus.$off('reloadActivity')
  },
  mounted() {
    Bus.$on('reloadActivity', () => {
      if (this.$store.state.site.missionCenterVisible) {
        this.init()
      }
    })
  },
  methods: {
    handleClose() {
      this.$store.commit('site/SET_MISSION_CENTER_VISIBLE', false)
    },
    async init() {
      this.inPwa = isPwa()
      if (this.userInfo?.id) {
        await getUserInfo(this)
      }
      await this.queryList()
    },
    async handleGetGift(item) {
      if (this.loading || this.editing) return
      this.loading = true
      const params = {
        gift_record_id: item.gift_record_id
      }
      const [err] = await this.$utils.to(this.$api.task.getGift(params))
      this.loading = false
      if (!err) {
        Message.success('Success')
        await this.init()
      } else {
        Message.error(err)
      }
    },
    async handleQuickGet() {
      if (this.loading || this.editing) return
      this.loading = true
      const [err] = await this.$utils.to(this.$api.task.quickGet())
      this.loading = false
      if (!err) {
        Message.success('Success')
        await this.init()
      } else {
        Message.error(err)
      }
    },
    handlePwaLoginSubmit() {
      if (this.editing) {
        return false
      } else if (this.inPwa && !this.userInfo?.id) {
        showLogin(this)
      } else if (!this.inPwa) {
        this.handleClose()
        Bus.$emit('pwaInstall')
      }
    },
    async queryList() {
      if (this.editing) {
        this.list = cloneDeep(this.model.__mockData)
        return
      }
      const params = {
        project_id: this.$store.state.project.projectId
      }
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.task.getList(params))
      this.loading = false
      if (!err) {
        this.list = (res.data || []).map(item => {
          const newItem = {...item}
          newItem.name = getLangIdI18n({ lang_id: item.name }, this.$store.state.locale.langIdData)
          return newItem
        })
      } else {
        Message.error(err)
      }
    }
  }
}
</script>

<style lang="less">
.mission-center-dialog {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.5);
  &__content {
    position: absolute !important;
    margin: auto;
    bottom: 0;
    top: 5vh;
    left: 0;
    right: 0;
    z-index: 3010;
    width: 720px;
    height: fit-content;
    background: var(--mission-background-color);
    color: var(--mission-text-color);
    border-radius: var(--mission-border-radius);
    .list {
      margin-top: 30px;
      min-height: 120px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        background: var(--mission-item-bg);
        border-radius: var(--mission-border-radius);
        .left-info {
          .name {
            font-size: 16px;
            font-weight: bold;
          }
          .gift-list {
            display: flex;
            margin-top: 20px;
            flex-wrap: wrap;
            gap: 10px;
            .gift-item {
              display: flex;
              align-items: center;
              img {
                width: 40px;
                height: 40px;
              }
            }
          }
        }
        .right-handle {
          padding: 6px 15px;
          border-radius: var(--mission-border-radius);
          font-size: 16px;
          margin-left: 60px;
          flex-shrink: 0;
          cursor: pointer;
          &.submit-type {
            background: var(--mission-submit-bg);
            color: var(--mission-submit-color);
          }
          &.get-type {
            background: var(--mission-get-bg);
            color: var(--mission-get-color);
          }
          &.done-type {
            background: var(--mission-done-bg);
            color: var(--mission-done-color);
          }
        }
      }
    }
    .quick-button {
      background: var(--mission-get-bg);
      width: fit-content;
      margin: 0 auto;
      padding: 6px 15px;
      border-radius: var(--mission-border-radius);
      font-size: 16px;
      color: var(--mission-get-color);
      cursor: pointer;
    }
    .handle-area {
      margin-top: 40px;
    }
  }
  &.is-mobile {
    .mission-center-dialog__content {
      width: 90%;
      .list {
        .item {
          .name {
            font-size: 14px;
          }
          .gift-item {
            font-size: 12px;
            img {
              width: 24px;
              height: 24px;
            }
          }
        }
      }
      .right-handle {
        font-size: 12px;
        margin-left: 20px;
      }
      .quick-button {
        font-size: 12px;
      }
      .handle-area {
        margin-top: 20px;
      }
    }
  }
}
</style>
